import styled from "styled-components";

export const SMaintenanceWarningLoginContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
